<template>
    <div component="Camera">
        <crop-pop-up v-show="showCropper" @save="cropSaved" @close="showCropper = false" ref="cropPopUp" />

        <popup :name="'permission'" :visible="showPermissionPopup" @close="showPermissionPopup = false">
            <h3>We need your permission to capture photos from your webcamera.</h3>
            <p>
                Please refresh page with <i class="material-icons refresh-icon">refresh</i> and click authorize if you
                change your mind.
            </p>

            <a class="button" size="" color="accent" @click="showPermissionPopup = false">
                <i class="icon">done</i><span>OK</span>
            </a>
        </popup>

        <transition name="camera">
            <div class="camera" v-if="getShowCamera">
                <div class="video">
                    <div class="close" :class="{ visible: getShowCamera }" @click="closeCapture">
                        <i class="material-icons">close</i>
                    </div>

                    <video id="player" ref="player" autoplay></video>
                    <canvas id="canvas" ref="canvas"></canvas>

                    <div class="capture" :class="{ visible: getShowCamera }" @click="capture">
                        <div class="icon">camera</div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';

import Popup from '@/components/.global/Popup.vue';
import CropPopUp from '@/components/Profile/Gallery/Cropper/CropPopUp.vue';

export default {
    name: 'capture',

    created() {
        this.cameraSupported = 'mediaDevices' in navigator;
    },

    mounted() {},

    data() {
        return {
            showPermissionPopup: false,
            firstPermissionAsk: true,
            showCropper: false,
            cameraSupported: false,
            constraints: {
                audio: false,
                video: {
                    width: {
                        ideal: 500,
                    },
                    height: {
                        ideal: 500,
                    },
                    // facingMode: {
                    //	   // Predna / Zadna kamera na mobile
                    //     exact: "environment"
                    // }
                },
            },
        };
    },

    computed: {
        ...mapGetters(['getShowCamera']),
    },

    watch: {
        getShowCamera(newVal, oldVal) {
            if (newVal && this.cameraSupported) {
                // Open camera

                this.constraints.video.width.ideal = window.innerWidth <= 600 ? window.innerWidth - 50 : 600;
                this.constraints.video.height.ideal = window.innerWidth <= 600 ? window.innerWidth - 50 : 600;

                navigator.mediaDevices
                    .getUserMedia(this.constraints)
                    .then((stream) => {
                        this.$refs.player.srcObject = stream;
                    })
                    .catch((err) => {
                        this.closeCapture();

                        if (err.name === 'NotAllowedError') {
                            this.showPermissionPopup = true;
                        } else {
                            this.$bugsnag.notify(e);
                        }
                    });
            } else if (!newVal) {
                // Hide Camera
                this.closeCapture();
            }
        },
    },

    methods: {
        ...mapMutations(['showCamera']),

        setCropper(image) {
            this.showCropper = true;
            this.$refs.cropPopUp.replace(image);
        },

        cropSaved(file) {
            this.showCropper = false;
            this.$_eventsDispatch('cropSaved', file);
        },

        closeCapture() {
            this.stopCapturing();
            this.showCamera(false);
            this.$emit('close', true);
        },

        capture() {
            this.$nextTick(() => {
                const canvas = this.$refs.canvas;
                const context = canvas.getContext('2d');

                canvas.width = 500;
                canvas.height = 500;

                context.drawImage(player, 0, 0, canvas.width, canvas.height);

                const dataURL = this.$refs.canvas.toDataURL('image/jpeg');
                const blob = this.dataURItoBlob(dataURL);

                this.setCropper(dataURL);

                if (this.closeOnCapture) {
                    this.closeCapture();
                }
            });
        },

        stopCapturing() {
            if (this.$refs.player && this.$refs.player.srcObject) {
                this.$refs.player.srcObject.getVideoTracks().forEach((track) => track.stop());
            }
        },

        dataURItoBlob(dataURI) {
            // convert base64/URLEncoded data component to raw binary data held in a string, for form-data
            var byteString;
            if (dataURI.split(',')[0].indexOf('base64') >= 0) byteString = atob(dataURI.split(',')[1]);
            else byteString = unescape(dataURI.split(',')[1]);
            // separate out the mime component
            var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
            // write the bytes of the string to a typed array
            var ia = new Uint8Array(byteString.length);
            for (var i = 0; i < byteString.length; i++) {
                ia[i] = byteString.charCodeAt(i);
            }
            return new Blob([ia], { type: mimeString });
        },
    },

    components: {
        CropPopUp,
        Popup,
    },

    props: {
        closeOnCapture: {
            type: Boolean,
            default: true,
        },
    },
};
</script>

<style lang="less" scoped>
@import '~@variables';

.refresh-icon {
    font-size: 15px;
}

[component='Camera'] {
    z-index: 999;
}

.camera {
    z-index: 999;

    &.visible {
        pointer-events: all;
    }

    .video {
        position: fixed;
        display: flex;
        top: 50%;
        transform: translateX(-50%) translateY(-50%);
        border: 4px solid #bbb;

        border-radius: 50%;
        overflow: hidden;
        left: 50%;
        min-width: 300px;
        min-height: 300px;
        background: #333;
        box-shadow: 0 10px 50px 5px rgba(0, 0, 0, 0.6);

        .close {
            position: absolute;
            top: 10px;
            left: 50%;
            transform: translateX(-50%);
            cursor: pointer;
            z-index: 99;
            color: #fff;

            i {
                transition: 0.5s all;
                font-size: 35px;
            }

            &.visible {
                animation: 1s 0.5s fadeIn backwards;
            }

            &:hover {
                i {
                    transform: rotate(180deg) scale(0.9);
                }
            }
        }

        .capture {
            position: absolute;
            width: 65px;
            height: 65px;
            border: 2px solid #bbb;
            background-color: fade(red, 10%);
            z-index: 99;
            cursor: pointer;
            bottom: 20px;
            left: 50%;
            transform: translateX(-50%);
            border-radius: 50%;
            transition: 0.5s all;
            .flex-center;
            color: white;

            &.visible {
                animation: 1s 0.5s fadeIn backwards;
            }

            &:hover {
                background-color: fade(#1c69d4, 20%);
            }
        }

        #canvas {
            display: none;
        }
    }
}

.camera-enter-active,
.camera-leave-active {
    transition: opacity 1s ease;
    pointer-events: all;

    .video {
        border-color: #bbb;
    }
}

.camera-enter,
.camera-leave-active {
    opacity: 0;
    pointer-events: none;
}

@keyframes fadeIn {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}
</style>
